module.exports = __webpack_public_path__ + "img/starrating.7e51772a.svg";